import React from 'react';
import PropTypes from 'prop-types';

const FieldErrorMessage = ({ message }) => (
    <p className={'message bad-form'}>{message}</p>
);

FieldErrorMessage.propTypes = {
    message: PropTypes.string,
};

FieldErrorMessage.defaultProps = {
    message: '',
};

export default FieldErrorMessage;
